import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Spinner, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";

import { getBooksList } from "../../api/bookService";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import bookimg1 from "../../assets/img/bookimg1.jpg"; 
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";
const OLT_icon = "https://d3bn54rc14fhr4.cloudfront.net/ss.png";


export default function BooksInfo() {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [userBookList, setUserBookList] = useState([]);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchBooks = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getBooksList();  // <-- No params here
      if (response?.data) {
        setUserBookList(response.data);
      } else {
        setError("Failed to retrieve books. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching books:", err);
      setError("An error occurred while fetching books.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const columns = [
    {
      name: 'SR No.',
      width: '80px',
      cell: (row, index) => index + 1,
    },
    {
      name: 'Cover',
      width: '100px',
      cell: (row) => (
        <img
          className="table_img rounded img-thumbnail"
          src={row.coverImage ? `${MEDIA_URL}/${row.coverImage}` : OLT_icon}
          alt="Book cover"
          width={50}
          height={50}
        />
      ),
    },
    {
      name: 'Title',
      minWidth: '200px',
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => row.title || 'N/A',
    },
    {
      name: 'Author',
      minWidth: '180px',
      selector: (row) => row.userId?.fullName || 'N/A',
      sortable: true,
      cell: (row) => (
        <Link 
          to={`/admin/view-user/${row.userId?._id}?tab=basicinfo`} 
          className="text-primary" 
          style={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          {row.userId?.fullName || 'N/A'}
        </Link>
      ),
    },
    {
      name: 'Username',
      minWidth: '180px',
      selector: (row) => row.userId?.username || 'N/A',
      sortable: true,
      cell: (row) => (
        <Link 
          to={`/admin/view-user/${row.userId?._id}?tab=basicinfo`} 
          className="text-primary" 
          style={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          {row.userId?.username || 'N/A'}
        </Link>
      ),
    },
    {
      name: 'Characters',
      width: '120px',
      selector: (row) => row.characterCount || 0,
      sortable: true,
    },
    {
      name: 'Chapters',
      width: '120px',
      selector: (row) => row.noOfChapters || 0,
      sortable: true,
    },
    {
      name: 'Date Created',
      width: '150px',
      selector: (row) => new Date(row.createdAt).getTime(),
      sortable: true,
      cell: (row) => {
        const date = new Date(row.createdAt);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
},
    {
      name: "Actions",
      minWidth: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/books/view-book/${row._id}`}>
            <Icon icon="tabler:eye" />
          </Link>
        </>
      ),
    },
  ];

  // Client side filtering
  const filteredData = userBookList.filter((item) =>
    item.title.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search by Title..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="text-center py-5">
                      <div
                                    className="text-center py-5"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "120px",
                                      width: "100%",
                                    }}
                                  >
                                    <TailSpin height={50} width={80} color="#4fa94d" />
                                  </div>
                    </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
              noDataComponent={<p className="text-center my-4">No books found</p>}
            />
          )}
        </Card.Body>
      </Card>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button onClick={handleClose} className="btn btn-primary px-4 min_width110">
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
